import { BrandThemeProvider } from '@montugroup/themes';
import { useLocation, useNavigate } from 'react-router-dom';

import OrderConfirmation from '@/components/payment/OrderConfirmation';
import { usePortalPartnerBrand } from '@/hooks/portal-partner-brand';
import { PATIENT_ORDERS_ROUTE } from '@/routes/route-paths';
import type { DELIVERY_OPTION, DELIVERY_OPTIONS } from '@montugroup/circuit-shared';
import useUser from '@montugroup/circuit-shared/hooks/user/useUser';

function PaymentSuccessAuth() {
  const { data: user } = useUser();
  const navigate = useNavigate();
  const location = useLocation();
  const { key: partnerKey } = usePortalPartnerBrand();

  const { orderCode, usedDeliveryOption } =
    (location.state as {
      orderCode: string;
      usedDeliveryOption?: (typeof DELIVERY_OPTIONS)[DELIVERY_OPTION]['name'];
    }) || {};

  if (!orderCode) {
    navigate(PATIENT_ORDERS_ROUTE);
  }

  return (
    <BrandThemeProvider theme={partnerKey}>
      <OrderConfirmation
        orderCode={orderCode}
        patientName={user?.firstName}
        patientEmail={user?.email}
        loggedIn
        deliveryOption={usedDeliveryOption}
      />
    </BrandThemeProvider>
  );
}

export default PaymentSuccessAuth;
